import { fetcher } from '../../http/Fetcher';
import type { SendOTPRequest, SendOTPResponse } from '../types/EnrollMfa';
import type { GetUserRequest } from '../types/GetUserRequest';
import type { User } from '../types/User';

const getUser = async (request: GetUserRequest): Promise<User | null> => {
    const { stytchId } = request;
    return await fetcher({
        method: 'GET',
        endpoint: `/api/user/find?stytch_id=${stytchId}`,
    });
};

const getPartialUser = async (
    request: GetUserRequest,
): Promise<User | null> => {
    const { stytchId } = request;
    return await fetcher({
        method: 'GET',
        endpoint: `/api/user/find-partial?stytch_id=${stytchId}`,
    });
};

const sendOtpCode = async (
    request: SendOTPRequest,
): Promise<SendOTPResponse> => {
    const body = JSON.stringify({ ...request });
    return await fetcher({
        method: 'POST',
        endpoint: '/api/mfa/send-otp',
        body,
    });
};

export { getPartialUser, getUser, sendOtpCode };
